import { Record } from 'immutable';
import { getOr, remove } from 'lodash/fp';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  employees: [],
  employee: {
    id: null,
  },
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.EMPLOYEES_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('employees', getOr(payload, 'data')(payload));
    case types.CREATE_EMPLOYEE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('employee', payload);
    case types.UPDATE_EMPLOYEE_PASSWORD_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.DELETE_EMPLOYEE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('employees', remove({ id: payload })(state.employees));
    case types.EMPLOYEES_REQUEST:
    case types.CREATE_EMPLOYEE_REQUEST:
    case types.UPDATE_EMPLOYEE_PASSWORD_REQUEST:
    case types.DELETE_EMPLOYEE_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.EMPLOYEES_FAILURE:
    case types.CREATE_EMPLOYEE_FAILURE:
    case types.UPDATE_EMPLOYEE_PASSWORD_FAILURE:
    case types.DELETE_EMPLOYEE_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_EMPLOYEE:
      return state.set('employee', {
        ...requestReducerState().employee,
      });
    default:
      return state;
  }
};
